import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { ITkInquiryTableListProps } from "./components/components";

const inquiryList: ITkInquiryTableListProps[][] = [
  [
    {
      title: "契約者番号",
      keyword: "contractorNo",
    },
    {
      title: "契約者名",
      keyword: "corpName",
      type: "link",
    },
  ],
  [
    {
      title: "施設番号",
      keyword: "facilityNo",
    },
    {
      title: "施設名",
      keyword: "facilityName",
      type: "link",
    },
  ],
  [],
  [
    {
      title: "ステータス",
      keyword: "status",
    },
  ],
  [
    {
      title: "職員番号",
      keyword: "staffNo",
    },
  ],
  [
    {
      title: "職員名（ﾌﾘｶﾞﾅ）",
      keyword: "staffNameKana",
    },
    {
      title: "旧姓（ﾌﾘｶﾞﾅ）",
      keyword: "bNameKana",
    },
  ],
  [
    {
      title: "職員名",
      keyword: "staffNameKanji",
    },
    {
      title: "旧姓",
      keyword: "bNameKanji",
    },
  ],
  [
    {
      title: "生年月日",
      keyword: "birthday",
    },
    {
      title: "性別",
      keyword: "sex",
    },
  ],
  [
    {
      title: "職種",
      keyword: "jobName",
    },
    {
      title: "加入資格",
      keyword: "joinCapacity",
    },
  ],
  [
    {
      title: "加入日",
      keyword: "joinDate",
    },
    {
      title: "加入取消日",
      keyword: "joinCancelDate",
    },
  ],
  [
    {
      title: "復帰期限",
      keyword: "deadlineDate",
    },
  ],
  [
    {
      title: "公費助成対象有無",
      keyword: "transitionalMeasuresFlg",
    },
  ],
  [
    {
      title: "掛金届の入力（4月1日在籍）",
      keyword: "enterPaymentNotification",
    },
  ],
  [
    {
      title: "俸給表の額（直近5年分）",
      keyword: "salaryTableAmt",
    },
  ],
  [
    {
      title: "俸給表の調整額（直近5年分）",
      keyword: "salaryAdjustmentAmt",
    },
  ],
  [
    {
      title: "合計（直近5年分）",
      keyword: "total",
    },
  ],
];

const demanderKbnList: any[] = [
  {
    label: "被共済職員原簿閲覧請求",
    value: "1",
  },
  {
    label: "退職手当金支給予定額の証明依頼",
    value: "2",
  },
  {
    label: "源泉徴収票の再発行",
    value: "3",
  },
  {
    label: "退職手当金の追加支給要望",
    value: "4",
  },
  {
    label: "掛金確定後の職員情報の訂正",
    value: "5",
  },
];

const demanderUserType: any[] = [
  {
    label: "共済契約者",
    value: "1",
  },
  {
    label: "法人職員",
    value: "2",
  },
  {
    label: "弁護士",
    value: "3",
  },
];

const monthMapping = {
  Apr: "4",
  May: "5",
  Jun: "6",
  Jul: "7",
  Aug: "8",
  Sep: "9",
  Oct: "10",
  Nov: "11",
  Dec: "12",
  Jan: "1",
  Feb: "2",
  Mar: "3",
} as any;

const commentHeader: any = [
  { headTitle: "当該職員に関するコメント", align: "left" },
];

const periodsHeaer: any = [
  { headTitle: "在籍期間・被共済職員期間等", align: "left" },
];

const unrecognizedMonthHeader: any = [
  {
    headTitle: "年度",
  },
  {
    headTitle: "ならない月数",
  },
  {
    headTitle: "ならない月",
  },
];

const childcareLeaveHeader: any = [
  {
    headTitle: "出生日",
  },
  {
    headTitle: "育児休業開始日",
  },
  {
    headTitle: "育児休業終了日",
  },
  {
    headTitle: "ならない月数",
  },
  {
    headTitle: "パパママ育休プラス",
  },
  {
    headTitle: "半年延長の理由",
  },
  {
    headTitle: "産後パパ育休",
  },
];

const transferHistoryHeader: any = [
  {
    headTitle: "異動内容",
  },
  {
    headTitle: "異動日",
  },
  {
    headTitle: "職員番号",
  },
  {
    headTitle: "契約者",
  },
  {
    headTitle: "施設",
  },
];

const retireInfoList: ITkFakeTableLineProps[] = [
  {
    title: "退職日",
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "退職届受付日",
    keyword: "retirementFormReceptionDate",
    type: "nodeInLine",
  },
  {
    title: "退職理由",
    keyword: "retireReason",
    type: "text",
  },
  {
    title: "退職手続きの理由",
    keyword: "retireProcedureReason",
    type: "text",
  },
  {
    title: "源泉徴収票の有無",
    keyword: "taxFlg",
    type: "text",
  },
  {
    title: "請求書受付日",
    keyword: "retirementInvoiceReceptionSate",
    type: "nodeInLine",
  },
  {
    title: "請求書未提出の理由",
    keyword: "formOnlyReason",
    type: "text",
  },
  {
    title: "合算制度受付日",
    keyword: "totalizationSystemReceptionDate",
    type: "text",
  },
  {
    title: "時効日",
    keyword: "limitationDate",
    type: "text",
  },
  {
    title: "時効日（延長後）",
    keyword: "limitationExtendedDate",
    type: "text",
  },
  {
    title: "時効日撤廃（取下）日",
    keyword: "limitationAbolitionApprovalDate",
    type: "text",
  },
  {
    title: "状況",
    keyword: "paymenStatus",
    type: "text",
  },
  {
    title: "送金日",
    keyword: "remitDueDate",
    type: "text",
  },
  {
    title: "計算基礎額",
    keyword: "baseAmt",
    type: "text",
    id: "amt",
  },
  {
    title: "支給乗率（現行制度）　金額修正",
    keyword: "paymentMultiplierId",
    type: "text",
  },
  {
    title: "支給乗率（経過措置の適用）",
    keyword: "tmPaymentMultiplier",
    type: "text",
  },
  {
    title: "退職金決定額",
    keyword: "amt",
    type: "text",
    id: "amt",
  },
  {
    title: "支給決定整理番号",
    keyword: "refNo",
    type: "text",
  },
  {
    title: "源泉徴収税額　国税",
    keyword: "nationalTaxAmt",
    type: "text",
    id: "amt",
  },
  {
    title: "源泉徴収税額　道府県民税",
    keyword: "prefectureTaxAmt",
    type: "text",
    id: "amt",
  },
  {
    title: "源泉徴収税額　市町村民税",
    keyword: "cityTaxAmt",
    type: "text",
    id: "amt",
  },
  {
    title: "預り金の有無",
    keyword: "presenceOrAbsenceOfDeposit",
    type: "text",
  },
  {
    title: "再送金口座登録有無",
    keyword: "registrationOfRemittanceAccount",
    type: "nodeInLine",
  },
  {
    title: "預り金督促日",
    keyword: "depositReminderDate",
    type: "text",
  },
  {
    title: "預り金時効日",
    keyword: "depositStatuteOfLimitationsDate",
    type: "text",
  },
  {
    title: "追加支給/返還の有無",
    keyword: "addPaymentApplyFlg",
    type: "nodeInLine",
  },
  {
    title: "追加支給/返還の事由",
    keyword: "addPaymentReason",
    type: "text",
  },
  {
    title: "支払額/返還額",
    keyword: "addPaymentAmt",
    type: "text",
    id: "amt",
  },
  {
    title: "退職金追加支給/返還日",
    keyword: "addRemitDueDate",
    type: "text",
  },
];

export {
  inquiryList,
  demanderKbnList,
  demanderUserType,
  monthMapping,
  commentHeader,
  periodsHeaer,
  unrecognizedMonthHeader,
  childcareLeaveHeader,
  transferHistoryHeader,
  retireInfoList,
};
